<div *ngIf="movementSchedulePrintPreviewData.currentMovementScheduleFlis.length > 0">
    <div *ngFor="let currentFli of movementSchedulePrintPreviewData.currentMovementScheduleFlis; let fliIndex = index">
        <ng-container [ngTemplateOutlet]="movementScheduleTablePrintPreview" [ngTemplateOutletContext]="{
                data: currentFli,
                dates: currentDates,
                fliIndex: fliIndex + 1,
                accordionIndex: accordionIndex,
                currentLanguage: currentLanguage,
                numberFormat: numberFormat
            }"></ng-container>

        <div *ngIf="movementSchedulePrintPreviewData.previousFlisOfCurrentFlis != null">
            <ng-container [ngTemplateOutlet]="movementScheduleTablePrintPreview" [ngTemplateOutletContext]="{
                    data: movementSchedulePrintPreviewData.previousFlisOfCurrentFlis.get(fliIndex),
                    dates: previousDates,
                    fliIndex: mockedIndex,
                    accordionIndex: mockedIndex,
                    currentLanguage: currentLanguage,
                    numberFormat: numberFormat
                }"></ng-container>
        </div>

        <ng-template #movementScheduleTablePrintPreview let-data="data" let-dates="dates" let-fliIndex="fliIndex"
            let-accordionIndex="accordionIndex" let-currentLanguage="currentLanguage" let-numberFormat="numberFormat">
            <aumico-notes-movements-schedule-table-print-preview-deprecated
                [stylePreferenceOptions]="stylePreferenceOptions" [data]="data" [dates]="dates" [fliIndex]="fliIndex"
                [accordionIndex]="accordionIndex" [currentLanguage]="currentLanguage" [numberFormat]="numberFormat"
                [noPreviousData]="noPreviousData">
            </aumico-notes-movements-schedule-table-print-preview-deprecated>
        </ng-template>
    </div>
</div>